import { useDispatch, useSelector } from 'react-redux';
import FJFake3dEdit from './FJFake3dEdit';
import FJActionFake3d from '../../../../redux/action/FJActionFake3d';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJFake3dEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const deepMapImage = useSelector(state => state.fake3d.deepMapImage);
    const originImage = useSelector(state => state.fake3d.originImage);
    const previewImage = useSelector(state => state.fake3d.previewImage);

    const uploadStatus = useSelector(state => state.fake3d.uploadStatus);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };
    const uploadImg = file => {
        dispatch(FJActionFake3d.uploadImageAction(file));
    };
    const cancelDepthMapTask = () => {
        dispatch(FJActionFake3d.cancelDepthMapTaskAction());
    };
    const onExport = () => {
        dispatch(FJActionFake3d.exportAction());
    };

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    return (
        <FJFake3dEdit
            openMediaLibrary={_openMediaLibrary}
            uploadImg={uploadImg}
            uploadStatus={uploadStatus}
            deepMapImage={deepMapImage}
            originImage={originImage}
            previewImage={previewImage}
            cancelDepthMapTask={cancelDepthMapTask}
            onExport={onExport}
            isDraggingFile={isDraggingFile}
            setIsDraggingFile={setIsDraggingFile}
        />
    );
};

export default FJFake3dEditContainer;
